import {BBModel} from '../bb_model';
import {context} from '../constants/context';
import {halClient} from '../hal';
import {Utils} from '../utils/utils';

const multiBasket = {

    async fetchAllBaskets(options = {}) {
        try {
            const url = `${context.apiUrl}/api/${context.apiVersion}/baskets`;
            const baskets = await halClient.$get(url, options)
                .then(basketsResource => basketsResource.$get('baskets'))
                .then(baskets => baskets.map(basket => new BBModel.MultiBasket(basket)));
            return baskets;

        } catch (err) {
            console.error(err);
        }

    },

    async fetchBasketsByCompanyId(companyId, options = {}) {
        try {
            const url = `${context.apiUrl}/api/${context.apiVersion}/baskets?company_id=${companyId}`;
            //TODO use baskets link on company https://bookingbug.atlassian.net/browse/CX-419
            options.no_cache = true;
            const baskets = await halClient.$get(url, options)
                .then(basketsResource => basketsResource.$get('baskets'))
                .then(baskets => baskets.map(basket => new BBModel.MultiBasket(basket)));

            for (const basket of baskets) {
                basket.addItems(await this.getItems(basket));
            }
            return baskets;

        } catch (err) {
            if (error.response.status) {
                throw error;
            }
        }
    },

    async createBasket(company) {
        try {
            const url = `${context.apiUrl}/api/${context.apiVersion}/baskets?company_id=${company.id}`;
            //TODO use baskets link on company https://bookingbug.atlassian.net/browse/CX-419

            const basketResource = await halClient.$post(url, { no_cache: true });
            const basket = new BBModel.MultiBasket(basketResource);
            basket.setCompany(company);
            return basket;
        } catch (error) {
            if (error.response.status) {
                throw error;
            }
        }
    },

    async fetchBasket(basket) {
        try {
            const basketResource = await basket.$get('self', { no_cache: true });
            const updatedBasket = new BBModel.MultiBasket(basketResource);
            const basketItems = await this.getItems(updatedBasket);
            updatedBasket.addItems(basketItems);
            return updatedBasket;
        } catch (error) {
            if (error.response.status) {
                throw error;
            }
        }
    },

    async refreshBasket(basket) {
        try {
            if (basket.$has('refresh')) {
                const basketResource = await basket.$put('refresh');
                const refreshedBasket = new BBModel.MultiBasket(basketResource);
                const basketItems = await this.getItems(refreshedBasket);
                refreshedBasket.addItems(basketItems);
                return refreshedBasket;
            }
        } catch (error) {
            if (error.response.status) {
                throw error;
            }
        }
    },

    async addServiceItem({basket, basketItem}) {
        try {
            if (basket.$has('service_items')) {
                const data = basketItem.getPostData();
                const serviceItemResource = await basket.$post('service_items', {}, data);
                const serviceItem = new BBModel.ServiceItem(serviceItemResource);
                return serviceItem;
            }
        } catch (error) {
            if (error.response.status) {
                throw error;
            }
        }
    },

    async updateServiceItem({basketItem}) {
        try {
            if (basketItem.$has('self')) {
                const data = basketItem.getPostData();
                const serviceItemResource = await basketItem.$put('self', {}, data);
                const serviceItem = new BBModel.ServiceItem(serviceItemResource);
                return serviceItem;
            }
        } catch (error) {
            if (error.response.status) {
                throw error;
            }
        }

    },

    async getItems(basket) {
        if (basket.$has('items')) {
            const items = await basket.$getItems();
            const basketItems = await this.setItemModels(items);
            return Utils.flatten(basketItems);
        }
    },

    async setItemModels(items) {
        const basketItems = [];
        for (const item of items) {
            switch (item.type) {
                case 'service_item': {
                    const serviceItem = new BBModel.ServiceItem(item);
                    await Promise.all(serviceItem.promises);
                    basketItems.push(serviceItem);
                    break;
                }
                case 'event_item': {
                    const eventItem = new BBModel.EventItem(item);
                    await Promise.all(eventItem.promises);
                    basketItems.push(eventItem);
                    break;
                }
                default: {
                    break;
                }
            }
        }

        return basketItems;
    },

    async checkout(basket, params = {}) {
        try {
            const data = basket.getPostData();
            if (basket.$has('checkout')) {
                const purchaseTotalResource = await basket.$post('checkout', params, data );
                const purchaseTotal = new BBModel.Purchase.Total(purchaseTotalResource);
                return purchaseTotal.getPurchaseData();
            }
        } catch (err) {
            console.error(err);
        }

    }


};


export {
    multiBasket
};
